import React from 'react';
import { Linkedin } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const About = () => {
  return (
    <section id="about" className="py-8 sm:py-12 lg:py-16 xl:py-20 bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="max-w-2xl sm:max-w-4xl lg:max-w-6xl xl:max-w-7xl mx-auto">
          {/* Content */}
          <div>
            <div className="text-center">
              <h2 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold text-gray-900 mb-4 sm:mb-6 lg:mb-8">
                Qui sommes-nous ?
              </h2>
              
              <div className="space-y-3 sm:space-y-4 lg:space-y-5 text-gray-600 leading-relaxed text-sm sm:text-base lg:text-lg xl:text-xl">
                <p>
                  SISENS, c'est avant tout la rencontre de deux entrepreneurs passionnés, tournés à 100 % vers le client, animés par une curiosité sincère, une agilité naturelle, et une vision humble mais ambitieuse du monde du service.
                </p>
                
                <p>
                  Issus de l'hospitalité globale et de la restauration collective et commerciale, nous avons uni nos expertises pour créer une entreprise qui place l'humain, le goût et le sens du service au cœur de chaque projet.
                </p>
                
                <p>
                  Chez SISENS, nous croyons que la restauration collective peut être un outil de performance, de bien-être, et de transformation des espaces de vie.
                </p>
                
                <p>
                  Notre ADN repose sur trois valeurs fondatrices : <strong className="text-[#4b9fcc]">audace, respect et solidarité</strong>. Elles guident notre manière de manager, de servir, et d'innover.
                </p>
                
                <p>
                  Dans un monde du travail en pleine mutation, nous imaginons des solutions sur mesure, locales, responsables et connectées, en phase avec les nouveaux usages et les attentes des utilisateurs.
                </p>
                
                <p>
                  <strong>SISENS, c'est une entreprise lyonnaise</strong>, fière de ses racines, portée par une équipe engagée, qui grandit avec ses clients et ses partenaires, dans une aventure à la fois économique et profondément humaine.
                </p>
              </div>
              
              {/* Section des directeurs responsive */}
              <div className="mt-8 sm:mt-10 lg:mt-12 xl:mt-16">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 lg:gap-10 xl:gap-12 justify-items-center max-w-xs sm:max-w-none mx-auto">
                  {/* Christophe GARNIER */}
                  <div className="text-center">
                    <div className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 xl:w-56 xl:h-56 mx-auto mb-3 sm:mb-4 lg:mb-5 rounded-lg overflow-hidden shadow-lg">
                      <img
                        src="https://customer-assets.emergentagent.com/job_54a67040-85b3-4cab-80e6-3d8b11a626e2/artifacts/n2cfljd6_LOGO%20%20CARRE.png"
                        alt="Portrait de Christophe GARNIER"
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                    <div className="flex items-center space-x-2 mt-4">
                      <h4 className="text-base sm:text-lg lg:text-xl font-semibold text-gray-900">Christophe GARNIER</h4>
                      <a 
                        href="https://www.linkedin.com/in/christophe-garnier-445a54188/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-[#0077B5] hover:text-[#004471] transition-colors duration-300 hover:scale-110 transform"
                      >
                        <Linkedin className="w-4 h-4" />
                      </a>
                    </div>
                    <p className="text-sm sm:text-base lg:text-lg text-[#4b9fcc] font-medium">
                      Président
                    </p>
                  </div>
                  
                  {/* Laurent KELMANOWITZ */}
                  <div className="text-center">
                    <div className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 xl:w-56 xl:h-56 mx-auto mb-3 sm:mb-4 lg:mb-5 rounded-lg overflow-hidden shadow-lg">
                      <img
                        src="https://customer-assets.emergentagent.com/job_54a67040-85b3-4cab-80e6-3d8b11a626e2/artifacts/9x1kick5_LOGO%20%20CARRE%20%281%29.png"
                        alt="Portrait de Laurent KELMANOWITZ"
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                    <div className="flex items-center space-x-2 mt-4">
                      <h4 className="text-base sm:text-lg lg:text-xl font-semibold text-gray-900">Laurent KELMANOWITZ</h4>
                      <a 
                        href="https://www.linkedin.com/in/laurent-kelmanowitz-2b53a163/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-[#0077B5] hover:text-[#004471] transition-colors duration-300 hover:scale-110 transform"
                      >
                        <Linkedin className="w-4 h-4" />
                      </a>
                    </div>
                    <p className="text-sm sm:text-base lg:text-lg text-[#4b9fcc] font-medium">
                      Directeur
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Section "Ils nous font confiance" */}
              <div className="mt-12 sm:mt-16 lg:mt-20">
                <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 text-center mb-8 sm:mb-10 lg:mb-12">
                  Ils nous font confiance :
                </h3>
                
                {/* Carrousel de logos */}
                <div className="relative overflow-hidden">
                  <div className="flex animate-scroll space-x-8 sm:space-x-12 lg:space-x-16">
                    {/* Premier jeu de logos - Tous en couleur */}
                    <div className="flex space-x-8 sm:space-x-12 lg:space-x-16 flex-shrink-0">
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/yr44e77b_LOGO%20ATELIER%20%287%29.png"
                          alt="Logo partenaire APEC"
                        className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/sim3lwrw_LOGO%20ATELIER%20%288%29.png"
                          alt="Logo partenaire EM Lyon"
                        className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/537q0eus_LOGO%20ATELIER%20%289%29.png"
                          alt="Logo partenaire SPIE"
                        className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/lf7ox182_LOGO%20ATELIER%20%2810%29.png"
                          alt="Logo partenaire AÉSIO"
                        className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/vszh3ljh_LOGO%20ATELIER%20%2811%29.png"
                          alt="Logo partenaire EDF"
                          className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/qvj4j12g_LOGO%20ATELIER%20%2812%29.png"
                          alt="Logo partenaire"
                          className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/6wjl8z7g_LOGO%20ATELIER%20%2813%29.png"
                          alt="Logo partenaire"
                          className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/izfmrjp8_LOGO%20ATELIER%20%2814%29.png"
                          alt="Logo partenaire"
                          className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/nseckep3_LOGO%20ATELIER%20%2815%29.png"
                          alt="Logo partenaire"
                          className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                    </div>
                    
                    {/* Duplication pour le défilement continu */}
                    <div className="flex space-x-8 sm:space-x-12 lg:space-x-16 flex-shrink-0">
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/yr44e77b_LOGO%20ATELIER%20%287%29.png"
                          alt="Logo partenaire APEC"
                        className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/sim3lwrw_LOGO%20ATELIER%20%288%29.png"
                          alt="Logo partenaire EM Lyon"
                        className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/537q0eus_LOGO%20ATELIER%20%289%29.png"
                          alt="Logo partenaire SPIE"
                        className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/lf7ox182_LOGO%20ATELIER%20%2810%29.png"
                          alt="Logo partenaire AÉSIO"
                        className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/vszh3ljh_LOGO%20ATELIER%20%2811%29.png"
                          alt="Logo partenaire EDF"
                          className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/qvj4j12g_LOGO%20ATELIER%20%2812%29.png"
                          alt="Logo partenaire"
                          className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/6wjl8z7g_LOGO%20ATELIER%20%2813%29.png"
                          alt="Logo partenaire"
                          className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/izfmrjp8_LOGO%20ATELIER%20%2814%29.png"
                          alt="Logo partenaire"
                          className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      <div className="h-16 sm:h-20 lg:h-24 w-20 sm:w-24 lg:w-28 flex items-center justify-center">
                        <img
                          src="https://customer-assets.emergentagent.com/job_15cba88e-9623-4150-b1b8-7d712e58aefe/artifacts/nseckep3_LOGO%20ATELIER%20%2815%29.png"
                          alt="Logo partenaire"
                          className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;